import React from 'react'

import { useIs3dPrintModel } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'

import fileOutlined from 'images/icons/svg/new_item_page/file-outlined.svg'

function EmptyState() {
  const is3dPrintModel = useIs3dPrintModel()
  return (
    <div className="use-cases-area__body-empty-container">
    <img src={fileOutlined} alt="File Outlined" />
    <span className="use-cases-area__body-empty-text">
      {is3dPrintModel
        ? (
          'See how this model looks when 3D printed' +
          ' - upload your prints to share your results and inspire others!'
        )
        : (
          'Be the first to showcase how this 3D model can be used in real-world projects' +
          ' - upload your images or videos to inspire others!'
        )
      }
    </span>
  </div>
  )
}

export default EmptyState
